import { AppError } from "./AppError.js";
import { CombinedError } from "../graphql/index.js";
class OfflineError extends AppError {
    constructor(){
        super({
            title: "It seems like you're offline",
            message: 'Check your network connection, and then refresh your browser'
        });
        Object.setPrototypeOf(this, OfflineError.prototype);
    }
}
function isOfflineError(error) {
    return error instanceof OfflineError || error instanceof TypeError && 'Failed to fetch' === error.message || error instanceof CombinedError && '[Network] Failed to fetch' === error.message;
}
export { OfflineError, isOfflineError };

//# sourceMappingURL=OfflineError.js.map